
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { toList, empty, singleton, append, delay, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";
import { LabelId } from "../Shared/Shared.js";
import { Label } from "../Shared/Category.js";
import { ofArray, empty as empty_1, toArray as toArray_1, singleton as singleton_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Helper_receiverTypeNameTranslation } from "../Shared/User.js";
import { unwrap, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { InfiniteTable } from "../Widgets/Table/InfiniteTable.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { withoutOnboardingTourQueryParams, whoHasWhatNavigateReceiversListWithListTourDone, isWhoHasWhatOnboardingReceiversListPhase, getQueryParams } from "../Common.js";
import { Permission, Permissions_has } from "../Shared/Roles.js";
import { usePermissions } from "../UserPermissions.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TourGuideLocale, TourGuide, TourStep } from "../Components/TourGuide.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SelectedTab, ToolboxControl } from "../Widgets/ToolboxControlWidget.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { SWR_getToolBoxes } from "../Requests/Toolbox.js";
import { Skeleton } from "../Components/Skeleton.js";

export function OverviewTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.DisplayName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("toolQuantity", "", t("toolbox.quantity_tool"), (dto_1) => (new CellContent(0, [dto_1.ToolQuantity])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("toolWithQuantity", "", t("toolbox.quantity_simple_tool"), (dto_2) => (new CellContent(0, [dto_2.ToolWithQuantityQuantity])), "text", "text")), delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? singleton(new ColumnDefinition$1("inspectionStatus", "", t("toolbox.inspection_status"), (dto_3) => (new CellContent(4, [singleton_1(new Label(new LabelId("00000000-0000-0000-0000-000000000000"), dto_3.HasUninspectedTools ? t("toolbox.uninspected_tools") : t("toolbox.all_tools_inspected"), dto_3.HasUninspectedTools ? "#dc3545" : "#28a745", true, undefined))])), "select", "text")) : empty(), delay(() => append(singleton(new ColumnDefinition$1("receiverType", "", t("general.receiver"), (dto_4) => (new CellContent(0, [Helper_receiverTypeNameTranslation(t, dto_4.ReceiverType)])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", "", t("general.location"), (dto_5) => {
        let matchValue;
        return new CellContent(0, [(matchValue = dto_5.LocationName, (matchValue == null) ? "" : matchValue)]);
    }, "locationSelect", "text")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_6) => (new CellContent(0, [defaultArg(dto_6.BusinessUnitName, "")])), "text", "text")) : empty(), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton(new ColumnDefinition$1("archived", "", t("user.is_archived"), (dto_7) => (new CellContent(0, [dto_7.IsArchived ? t("general.yes") : t("general.no")])), "select", "text")) : empty())))))))))))))))));
    return createElement(InfiniteTable, (TableRows = toArray_1(props.Receivers), {
        ColumnDefinitions: columnDefinitions,
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultColumnFilter: unwrap(isFeatureEnabled(new Feature(6, [])) ? singleton_1({
                id: "archived",
                value: [t("general.no")],
            }) : undefined),
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto_8) => RouterModule_encodeParts(ofArray(["receivers", dto_8.UserId + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: true,
        },
        TableKey: "receiver-overview-table",
        TableRows: TableRows,
    }));
}

function ReceiversOverview(props) {
    let elems_1;
    const t = useTranslation()[0];
    const canReadReceiverTypes = Permissions_has(usePermissions(), new Permission(41, []));
    const showWhoHasWhatTour = isWhoHasWhatOnboardingReceiversListPhase();
    const whoHasWhatTableStep = new TourStep("[data-test-id=\'toolbox-receivers-overview-table\']", t("onboarding.tour.who_has_what_table_title"), reactElement("div", {
        children: t("onboarding.tour.who_has_what_table_content"),
    }), "top", false);
    const whoHasWhatSteps = canReadReceiverTypes ? ofArray([new TourStep("[data-test-id=\'toolbox-receiver-type-tabs\']", t("onboarding.tour.who_has_what_type_tabs_title"), reactElement("div", {
        children: t("onboarding.tour.who_has_what_type_tabs_content"),
    }), "bottom", false), whoHasWhatTableStep]) : singleton_1(whoHasWhatTableStep);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => append(canReadReceiverTypes ? singleton(createElement(ToolboxControl, {
        CustomerConfiguration: props.CustomerConfiguration,
        SelectedTab: new SelectedTab(0, []),
        UserData: props.UserData,
    })) : empty(), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["data-test-id", "toolbox-receivers-overview-table"], ["className", join(" ", ["h-full"])], (elems = [createElement(OverviewTable, {
            AccountSettings: props.AccountSettings,
            Dispatch: props.Dispatch,
            Receivers: props.Receivers,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (showWhoHasWhatTour ? singleton(createElement(TourGuide, {
            IsRunning: true,
            Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
            OnFinish: () => {
                whoHasWhatNavigateReceiversListWithListTourDone();
            },
            OnSkip: () => {
                RouterModule_nav(singleton_1("receivers" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
            },
            ScrollFirstStep: false,
            Steps: whoHasWhatSteps,
        })) : empty())));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ReceiversOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const toolBoxes = SWR_getToolBoxes();
    const matchValue_1 = toolBoxes.data;
    const matchValue_2 = state_1.CustomerConfiguration;
    const matchValue_3 = state_1.AccountSettings;
    let matchResult, accountSettings, customerConfiguration, toolBoxes_1;
    if (toolBoxes.error != null) {
        if (matchValue_1 == null) {
            matchResult = 1;
        }
        else if (matchValue_2.tag === 0) {
            matchResult = 1;
        }
        else if (matchValue_3.tag === 0) {
            matchResult = 1;
        }
        else {
            matchResult = 2;
        }
    }
    else if (matchValue_1 == null) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        customerConfiguration = matchValue_2.fields[0];
        toolBoxes_1 = matchValue_1;
    }
    switch (matchResult) {
        case 0:
            return createElement(ReceiversOverview, {
                AccountSettings: accountSettings,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Receivers: toolBoxes_1,
                UserData: state_1.UserData,
            });
        case 1:
            return createElement(Skeleton, {
                Variant: "table",
            });
        default:
            return reactElement("div", {
                children: ["Error"],
            });
    }
}

